export default __webpack_public_path__ + "static/casestudy-analyticsImage-9b908e9a6c1a8c6475b08c76c7cb392d.png";